export { default } from './Collaboracio';
